import { SendMessageSentryOptions } from "./types";

declare global {
  interface Window {
    Sentry?: {
      captureMessage?: (
        message: string,
        context?: {
          level?: string;
          extra?: Record<string, unknown>;
        }
      ) => void;
    };
  }
}

export const sendMessageSentry = ({ messageError, level = "warning", extra }: SendMessageSentryOptions) => {
  try {
    if (typeof window === "undefined") return;
    if (!window.Sentry || typeof window.Sentry.captureMessage !== "function") return;

    window.Sentry.captureMessage(messageError, {
      level,
      extra
    });
  } catch (error) {
    console.warn("sendMessageSentry: no fue posible registrar el mensaje en Sentry", error);
  }
};

export default sendMessageSentry;
